<template>
  <div>
    <v-card
      flat
      class="pt-4"
    >
      <v-simple-table dense class="pt-2">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-uppercase">
              Registered District/Club
            </th>
            <th class="text-uppercase">
              Position
            </th>
            <th class="text-uppercase">
              Effective Date
            </th>
            <th class="text-uppercase">
              Status
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="item in data"
            :key="item.id"
          >
            <td>
              {{ item.district.district_name}}
            </td>
            <td>
              {{ item.position }}
            </td>
            <td>
              {{ item.date_started }}
            </td>
            <td>
              {{ item.is_active===0?'ACTIVE':'DEACTIVATED' }}
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </div>
</template>

<script>

  export default {
    props: {
      data: Array,
    },
    methods: {
      formatPrice(value) {
        let val = (value / 1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
    }
  }
</script>
